import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { cnBem } from "../../../../shared/lib";
import { selectDynamicFormHeight, selectImageUrlGroup } from "../../../../entities/content/model";
import { selectImgPreviewTypeUpload, selectIsImgPreviewOpen } from "../../../../entities/message/model";
import styles from "./styles.pcss";
var cnImgPreview = cnBem('img-preview', styles);
export var ImgPreviewRender = function ImgPreviewRender(_ref) {
  var imageUrlGroup = _ref.imageUrlGroup,
    dynamicFormHeight = _ref.dynamicFormHeight,
    isTypeUpload = _ref.isTypeUpload;
  var isMobile = useIsMobileDimension();
  var headerHeight = isMobile ? 76 : 92;
  var _ref2 = imageUrlGroup || {},
    filePreviewUrl = _ref2.filePreviewUrl,
    fileUrl = _ref2.fileUrl,
    imageSettings = _ref2.imageSettings;
  var srcImg = !isTypeUpload && fileUrl ? fileUrl : filePreviewUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: cnImgPreview({
      upload: isTypeUpload
    }),
    style: _defineProperty(_defineProperty({}, '--img-top-margin', "".concat(headerHeight, "px")), '--img-bottom-margin', "".concat(isTypeUpload ? dynamicFormHeight : 0, "px"))
  }, srcImg && /*#__PURE__*/React.createElement("img", {
    alt: "\u043F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043D\u043E\u0435 \u0444\u043E\u0442\u043E",
    className: cnImgPreview('img', {
      orientation: ((imageSettings === null || imageSettings === void 0 ? void 0 : imageSettings.ratio) || 1) >= 1 ? 'horizontal' : 'vertical'
    }),
    src: srcImg
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    dynamicFormHeight: selectDynamicFormHeight(state),
    imageUrlGroup: selectImageUrlGroup(state),
    isTypeUpload: selectImgPreviewTypeUpload(state),
    shouldRender: selectIsImgPreviewOpen(state)
  };
};
export var ImgPreview = compose(connect(mapStateToProps), withRenderFlag)(ImgPreviewRender);